import { AxiosResponse } from 'axios';

import { SUBSCRIPTION_REQUEST_TIME_OUT } from '@/constants';
import { Organization } from '@/types/organization';
import {
  ConfirmedProjectSubscriptionRequest,
  SubscriptionRequestErrors,
} from '@/types/subscriptions/request';
import {
  Subscription,
  SubscriptionDetail,
} from '@/types/subscriptions/subscription';
import { api } from '@/services/api/axios/instance';

type UpdateParams = {
  data: {
    organizationId: Organization['id'];
    subscriptionRequest: ConfirmedProjectSubscriptionRequest;
    requestCode?: Subscription['requestCode'];
  };
  params: { dryrun: boolean };
};

export const confirmedSubscriptionRequestsApi = {
  update: async (
    config: UpdateParams,
  ): Promise<{
    subscription: SubscriptionDetail;
    warnings: SubscriptionRequestErrors | null;
  }> => {
    const { organizationId, subscriptionRequest, requestCode } = config.data;
    const { dryrun } = config.params;
    const path = `organizations/${organizationId}/confirmed_corporate_subscriptions/${requestCode}`;

    const data = {
      ...subscriptionRequest,
      dryrun,
    };

    const {
      data: { corporateSubscription: subscription, warnings },
    }: AxiosResponse<{
      corporateSubscription: SubscriptionDetail;
      warnings?: SubscriptionRequestErrors;
    }> = await api.patch(path, data, {
      timeout: SUBSCRIPTION_REQUEST_TIME_OUT,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    });

    return {
      subscription,
      warnings: warnings || null,
    };
  },
};
